import { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { Trigger } from 'src/app/models/trigger';

export const saveTimingRules = createAction(
  '[Timing Rules] Save Timing Rules',
  props<{ studyId: number; interventionId: number; moduleId: number; triggers: Trigger[] }>()
);

export const saveTimingRulesSuccess = createAction(
  '[Timing Rules] Save Timing Rules Success',
  props<{ savedTriggers: Trigger[] }>()
);

export const saveTimingRulesError = createAction(
  '[Timing Rules] Save Timing Rules Error',
  props<{ err: HttpErrorResponse }>()
);
